/* eslint-disable eqeqeq */
/* eslint-disable max-len */
/* eslint-disable consistent-return */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/button-has-type */
import React, {
  useState, useMemo, useRef, useEffect,
} from "react";
import "../../../styles/DuplicateTable.css";

const getRowId = (row) => row.documentId || row.caseId;

const DuplicateTable = ({
  columns,
  data,
  onTagPrimary,
  onRowSelect,
  emptyComponent,
  title,

}) => {
  const [search, setSearch] = useState("");
  const [sortConfig, setSortConfig] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [expanded, setExpanded] = useState(true);
  const [overflow, setOverflow] = useState(true);

  /* 🔍 Search */
  const filteredData = useMemo(() => {
    if (!data) return [];
    setSelectedRows([]);
    return data.filter((row) => Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase()));
  }, [data, search]);

  /* 🔃 Sorting */
  const sortedData = useMemo(() => {
    if (!sortConfig?.key) return filteredData;

    return [...filteredData].sort((a, b) => {
      const aVal = a[sortConfig.key];
      const bVal = b[sortConfig.key];

      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredData, sortConfig]);

  /* 🔀 Sorting handler */
  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (!prev || prev.key !== key) {
        return { key, direction: "asc" };
      }
      return {
        key,
        direction: prev.direction === "asc" ? "desc" : "asc",
      };
    });
  };

  const handleRowSelect = (row) => {
    setSelectedRows((prev) => {
      const rowId = getRowId(row);
      const exists = prev.some((r) => getRowId(r) === rowId);

      const updated = exists
        ? prev.filter((r) => getRowId(r) !== rowId)
        : [...prev, row];

      onRowSelect?.(updated);
      return updated;
    });
  };
  // const checkScroll = () => {
  //   if (overflow == true) {
  //     setTimeout(()=>{
  //       setOverflow(prev => !prev)
  //     },350)
  //   } else {
  //   }
  // }
  useEffect(() => {
  // Collapse → update immediately
    if (!expanded) {
      setOverflow(true);
      return;
    }
    // Expand → delay overflow change
    const timer = setTimeout(() => {
      setOverflow(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [expanded]);
  // const handleCollapseClick = () => {
  //   setTimeout(() => {
  //     setExpanded(prev => !prev)
  //   }, 3000);
  // }
  // const tableRef = useRef(null);

  // useEffect(()=> {
  //   const tableHeight = tableRef.current.offsetHeight;
  //   console.log(tableHeight,'ta eight')
  // })

  return (
    <div className={`table-container ${(title === 'Primary Application Details' || title === "Application Details") && expanded ? 'collapsable' : ''} ${title === 'Primary Application Details' && overflow ? 'scrollable' : ''}`}>
      {(title === 'Primary Application Details' || title === "Application Details") && (
      <div className={`table-collapse ${expanded ? 'rotate' : ''}`} onClick={() => { setExpanded((prev) => !prev); }}>
        {/* {title == 'Primary Application Details' && <div className={`table-collapse ${expanded ? 'rotate' : ''}`} onClick={handleCollapseClick}> */}
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="mask0_6378_67353" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="#D9D9D9" />
          </mask>
          <g mask="url(#mask0_6378_67353)">
            <path d="M12 15.4L6 9.4L7.4 8L12 12.6L16.6 8L18 9.4L12 15.4Z" fill="black" />
          </g>
        </svg>
      </div>
      )}
      <table className={`custom-table ${
    (title === "Primary Application Details" || title === "Application Details") && expanded
      ? "expanded"
      : !(title === "Primary Application Details" || title === "Application Details")
      ? "defaultStickyTable"
      : ""
  }`}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th
                key={col.accessor || col.header}
                onClick={() => col.accessor && handleSort(col.accessor)}
              >
                {col.header}
                {sortConfig?.key === col.accessor
                  && (sortConfig.direction === "asc" ? " ▲" : " ▼")}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {sortedData.length === 0 ? (
            emptyComponent ? (
              <tr>
                <td colSpan={columns.length}>{emptyComponent}</td>
              </tr>
            ) : (
              <tr>
                <td colSpan={columns.length} style={{ textAlign: "center" }}>
                  No data found
                </td>
              </tr>
            )
          ) : (

            sortedData.map((row) => {
              const rowId = getRowId(row);
              const isSelected = selectedRows.some(
                (r) => getRowId(r) === rowId,
              );

              return (
                <React.Fragment key={rowId}>
                  {/* 🔹 PRIMARY APPLICATION ROW */}
                  <tr className={isSelected ? "row-selected" : ""}>
                    {columns.map((col) => (
                      <td key={col.accessor || col.header}>
                        {col.render
                          ? col.render(
                            row[col.accessor],
                            row,
                            onTagPrimary,
                            handleRowSelect,
                          )
                          : row[col.accessor]}
                      </td>
                    ))}
                  </tr>

                  {/* 🔹 DETAIL ROWS */}
                  {row.details?.map((section, idx) => (
                    <tr
                      key={`${rowId}-detail-${idx}`}
                      className="detail-row"
                    >
                      <td colSpan={columns.length}>
                        <div className="detail-section">
                          <div className="detail-title">
                            {section.title}
                          </div>

                          <div className="detail-grid">
                            {Object.entries(section.fields).map(
                              ([key, value]) => (
                                <div key={key} className="detail-item">
                                  <div className="detail-label">{key}</div>
                                  <div className="detail-value">
                                    {value ?? "-"}
                                  </div>
                                </div>
                              ),
                            )}
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </React.Fragment>
              );
            })
          )}
        </tbody>
      </table>

    </div>
  );
};

export default DuplicateTable;
